app.service("OperationAPI", [
	"$http",
	"ENV",
	"Session",
	"OperationNote",
	function ($http, ENV, Session, OperationNote) {
		const mockResponse = {
			workup_id: "40ad187f-548a-4e77-ae62-a0ae0a4dea6b",
			patient_id: 12,
			completed_by_user_id: 123,
			surgeon_user_id: null,
			assistant_user_id: null,
			status: "COMPLETED",
			date_created: "2020-09-08T20:12:05",
			date_updated: "2020-09-20T11:15:52",
			op_note_od: {
				operative_eye: "YES",
				procedure_type: "PHACO_IOL",
				anaesthetic: "TOPICAL_INTRACAMERAL",
				incisions: [
					{
						size: 1.1,
						enlargement: "NO",
						location_degree: 90,
						location_type: "CORNEAL",
					},
				],
				ovd: ["Duovisc", "Healon", "test"],
				ccc: {
					dilated_pupil_size: "_7_5mm",
					pupil_expander: "IRIS_HOOKS",
					technique_type: "Cystotome",
					hydrodissection_type: "ANAESTHETIC",
				},
				phaco: {
					machine: "Infinity",
					technique: "divide_and_conquer",
					irrigation: "unipak",
					ultrasound_energy: 90,
				},
				iol: {
					lens_type: "TORIC",
					lens_model: "My lens model",
					lens_power_spherical: -0.5,
					lens_placement: "sulcus",
				},
				intraoperative_medications: [
					{
						medication: "subconjunctival cefazolin",
					},
				],
				adjuvant_procedures: {
					vision_blue: "YES",
					intracameral_phenylephrine: "YES",
					triamcinolone: "NO",
					iris_hooks: "NO",
					malyugan_ring: "YES",
					planned_anterior_vitrectomy: "YES",
					unplanned_anterior_vitrectomy: "NO",
					unplanned_posterior_vitrectomy: "YES",
					sulcus: "NO",
					capsular_tension_ring: "NO",
					intravitreal_injection: "NO",
					migs: "NO",
					corneal_suture: "YES",
					other: [
						{
							text: "something...",
						},
					],
				},
				complications: {
					iris_prolapse: "YES",
					anterior_capsular_runout: "NO",
					zonular_dialysis: "NO",
					posterior_capsular_rupture: "NO",
					vitreous_loss: "YES",
					dropped_nucleus: "YES",
					wound_leak: "NO",
					wound_burn: "NO",
					suprachoridal_haemorrhage: "YES",
					other: [
						{
							text: "something...",
						},
					],
				},
				comment: "free texts...",
			},
			op_note_os: {
				operative_eye: "YES",
				procedure_type: "PHACO_IOL",
				anaesthetic: "TOPICAL_INTRACAMERAL",
				incisions: [
					{
						size: 1.1,
						enlargement: "NO",
						location_degree: 90,
						location_type: "CORNEAL",
					},
				],
				ovd: ["Duovisc"],
				ccc: {
					dilated_pupil_size: "_4mm",
					pupil_expander: "NONE",
					technique_type: "CYSTOTOME",
					hydrodissection_type: "ANAESTHETIC",
				},
				phaco: {
					machine: "Infinity",
					technique: "divide_and_conquer",
					irrigation: "unipak",
					ultrasound_energy: 90,
				},
				iol: {
					lens_type: "TORIC",
					lens_model: "My lens model",
					lens_power_spherical: -0.5,
					lens_placement: "sulcus",
				},
				intraoperative_medications: [
					{
						medication: "subconjunctival cefazolin",
					},
				],
				adjuvant_procedures: {
					vision_blue: "YES",
					intracameral_phenylephrine: "YES",
					triamcinolone: "NO",
					iris_hooks: "NO",
					malyugan_ring: "YES",
					planned_anterior_vitrectomy: "YES",
					unplanned_anterior_vitrectomy: "NO",
					unplanned_posterior_vitrectomy: "YES",
					sulcus: "NO",
					capsular_tension_ring: "NO",
					intravitreal_injection: "NO",
					migs: "NO",
					corneal_suture: "YES",
					other: [
						{
							text: "something...",
						},
					],
				},
				complications: {
					iris_prolapse: "YES",
					anterior_capsular_runout: "NO",
					zonular_dialysis: "NO",
					posterior_capsular_rupture: "NO",
					vitreous_loss: "YES",
					dropped_nucleus: "YES",
					wound_leak: "NO",
					wound_burn: "NO",
					suprachoridal_haemorrhage: "YES",
					other: [
						{
							text: "something...",
						},
					],
				},
				comment: "free texts...",
			},
			postop_medications: [
				{
					medication: "free text",
					dose: "one or free text",
					frequency: 1,
					route: "OD",
					duration: 14,
				},
			],
			postop_care: {
				duration: "OTHER",
				other_date: "2020-09-30",
				clinician: "any text...",
			},
		};

		function hasSameProcedures(item1, item2) {
			// Compare primary procedure
			if (
				item1.primary_procedure?.concept_id !==
				item2.primary_procedure?.concept_id
			) {
				return false;
			}

			const list1 = item1.secondary_procedure_list || [];
			const list2 = item2.secondary_procedure_list || [];

			// Compare lengths
			if (list1.length !== list2.length) {
				return false;
			}

			// Compare concept_ids (order does not matter)
			const ids1 = list1.map(x => x.concept_id).sort();
			const ids2 = list2.map(x => x.concept_id).sort();

			return ids1.every((id, index) => id === ids2[index]);
		}

		function existsInArray(otherProcedureList, otherProcedure) {
			return otherProcedureList.some(item => hasSameProcedures(item, otherProcedure));
		}

		// Fields on an op-note eye section that describe this patient's operation rather than the
		// surgeon's defaults. Everything else on the section is a default for its procedure type.
		const PATIENT_ONLY_EYE_FIELDS = ["operative_eye", "payer", "comment", "complications", "adjuvant_procedures", "other_procedure"];

		function toEyeSetting(section, postopCare) {
			if (!section || section.operative_eye !== "YES" || !section.procedure_type) {
				return null;
			}
			const setting = {};
			Object.keys(section).forEach((key) => {
				if (PATIENT_ONLY_EYE_FIELDS.indexOf(key) === -1) {
					setting[key] = section[key];
				}
			});
			setting.postop_care = postopCare;
			return setting;
		}

		function toOtherProcedureSetting(section, postopCare) {
			if (!section || section.operative_eye !== "YES" || section.procedure_type !== "OTHER") {
				return null;
			}
			return {
				...section.other_procedure,
				instructions_for_patient: section.instructions_for_patient,
				anaesthetic: section.anaesthetic,
				postop_medications: section.postop_medications, // already filtered to this eye by the caller
				intraoperative_medications: section.intraoperative_medications,
				postop_care: postopCare,
			};
		}

		// The server replaces the favourite list with whatever is sent, so it can only be rebuilt from
		// a copy that was actually loaded for this user. Without one (the settings request failed, is
		// still in flight, or belongs to another surgeon) null is sent, which the server reads as
		// "leave the saved list alone" rather than wiping it.
		function withNewFavourites(otherSettings) {
			const cached = OperationNote.setting;
			if (!cached || Number(cached.user_id) !== parseInt(Session.userId, 10)) {
				return null;
			}
			let favourites = (cached.op_note_settings && cached.op_note_settings.favorite_procedure_list) || [];
			otherSettings.forEach((other) => {
				if (!other || !other.primary_procedure) {
					return;
				}
				const combination = {
					primary_procedure: other.primary_procedure,
					secondary_procedure_list: other.secondary_procedure_list || [],
				};
				if (!existsInArray(favourites, combination)) {
					favourites = [...favourites, combination];
				}
			});
			return favourites;
		}

		var service = {
			isProcessing: false,
			getOperationNotes: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/operation_note/patient/" + patientId + "/summary",
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				})
					.then(function (response) {
						if (response.data.length > 0) {
							OperationNote.setNoteHistory(angular.copy(response.data));
							OperationNote.setData({});
						} else {
							const newRecord = {
								completed_by_user_id: Session.userId,
								patient_id: patientId,
								surgeon_user_id: null,
								assistant_user_id: null,
								practice_id: Session.practice.id,
								op_note_od: {},
								op_note_os: {},
								postop_care: {
									duration: null,
								},
							};
							OperationNote.setData(newRecord);
							OperationNote.setNoteHistory([]);
						}
					})
					.catch(function (err) {
						console.error("operation note request failed", err && err.status);
						// OperationNote.setData(mockResponse);
					});
			},
			getWorkUp: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/operation_note/patient/" + patientId,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				})
					.then(function (response) {
						// console.log(`res=${JSON.stringify(response)}`);
						// OperationNote.setData(mockResponse);
						if (response.data.operation_note_id == null) {
							const newRecord = {
								...response.data,
								completed_by_user_id: Session.userId,
								patient_id: patientId,
								surgeon_user_id: null,
								assistant_user_id: null,
								practice_id: Session.practice.id,
								op_note_od: {},
								op_note_os: {},
								postop_care: {
									duration: null,
								},
							};
							OperationNote.setData(newRecord);
						} else {
							OperationNote.setData(response.data);
						}
					})
					.catch(function (err) {
						console.error("operation note request failed", err && err.status);
						// OperationNote.setData(mockResponse);
					});
			},
			submitWorkUp: function (requestData, option) {

				const parameters = [];
				if (option && option.addAutoTaskHistology === "true") {
					parameters.push("addAutoTaskHistology=true");
				} else if (option && option.addAutoTaskHistology === "false") {
					parameters.push("addAutoTaskHistology=false");
				}
	
				if(option && option.addAutoTaskOpNote === 'true'){
					parameters.push('addAutoTaskOpNote=true');
				}else if(option && option.addAutoTaskOpNote === 'false'){
					parameters.push('addAutoTaskOpNote=false');
				}

				return $http({
					method: "POST",
					url: ENV.API + `/api/operation_note/${parameters.length > 0 ? `?${parameters.join('&')}` : ''}`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					responseType: "arraybuffer",
					data: requestData,
				});
			},
			addNewComment: function (patient_id, operation_note_uuid, commentBody) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/operation_note/patient/${patient_id}/${operation_note_uuid}/comments`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					data: commentBody,
				});
			},
			saveDefaultSetting: function (body, saveToAllClinics) {
				// body is the op note with the non-operative eye already dropped. A cataract eye becomes
				// the default for its procedure type; an OTHER eye becomes an other-procedure default keyed
				// by its SNOMED combination. Post-op care travels inside each default.
				const otherSetting_od = toOtherProcedureSetting(body.op_note_od, body.postop_care);
				const otherSetting_os = toOtherProcedureSetting(body.op_note_os, body.postop_care);

				const dataTransform = {
					user_id: Session.userId,
					practice_id: body.practice_id,
					op_note_settings: {
						op_note_od_settings: otherSetting_od ? null : toEyeSetting(body.op_note_od, body.postop_care),
						op_note_os_settings: otherSetting_os ? null : toEyeSetting(body.op_note_os, body.postop_care),
						op_note_od_other_procedure_settings: otherSetting_od,
						op_note_os_other_procedure_settings: otherSetting_os,
						favorite_procedure_list: withNewFavourites([otherSetting_od, otherSetting_os]),
					},
				};

				return $http({
					method: "POST",
					url: ENV.API + `/api/operation_note/settings?applyToAllUserPractices=${saveToAllClinics === true}`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					data: dataTransform,
				});
			},
			getDefaultSetting: function (surgeonId,patientId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/operation_note/settings/${surgeonId}?practiceId=${Session.practice.id}&patientId=${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
				})
					.then(function (response) {
						OperationNote.setDefaultSetting(response.data);
					})
					.catch(function (err) {
						console.error("operation note request failed", err && err.status);
						// OperationNote.setData(mockResponse);
					});
			},
			saveFavouriteProcedure: function (payload) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/operation_note/settings?applyToAllUserPractices=true`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					data: payload,
				});
			},
			downloadPDF: function (patientId, operationNoteId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/operation_note/patient/${patientId}/${operationNoteId}/pdf`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					responseType: "arraybuffer",
				});
			},
			deleteOpNote: function(patientId,documentId) {
				return $http({
					method: "DELETE",
					url: ENV.API + `/api/operation_note/${documentId}/patient/${patientId}/archive`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				})
			},
			restoreOpNote: function(patientId,documentId) {
				return $http({
					method: "PUT",
					url: ENV.API + `/api/operation_note/${documentId}/patient/${patientId}/archive`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				})
			}
		};
		return service;
	},
]);
